import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';

@Component({
    selector: 'app-textarea-field',
    imports: [IonicModule],
    template: `
        @if (readonly) {
            <ion-item lines="none">
                <ion-label>
                    <p class="field-label">{{ field.label }}</p>
                    <p class="field-value">{{ value || '-' }}</p>
                </ion-label>
            </ion-item>
        } @else {
            <ion-item>
                <ion-label position="stacked">{{ field.label }}</ion-label>
                <ion-textarea
                    [placeholder]="field.placeholder || ''"
                    [value]="value"
                    [required]="isRequired"
                    [autoGrow]="true"
                    (ionInput)="onInput($event)">
                </ion-textarea>
            </ion-item>
            @if (field.helpText) {
                <ion-note class="field-help">{{ field.helpText }}</ion-note>
            }
        }
    `,
    styles: [`
        .field-help {
            padding: 4px 16px;
            font-size: 12px;
        }
        .field-label {
            color: var(--ion-color-medium);
            font-size: 12px;
        }
        .field-value {
            white-space: pre-wrap;
        }
    `]
})
export class TextareaFieldComponent extends BaseFieldComponent {
    initialize(value: any): void {
        this.value = value ?? '';
    }

    serialize(): any {
        return this.value;
    }

    onInput(event: any): void {
        this.emitChange(event.detail.value);
    }
}
